exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".margin-zero {\n  margin: 0 !important; }\n\n.margin-vertical-5 {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.location-address {\n  margin-top: 5px;\n  margin-bottom: 0px; }\n\n.coin-container {\n  position: relative; }\n  .coin-container .coin-total {\n    position: absolute;\n    bottom: 0px;\n    right: 10px; }\n\n.route_table_view {\n  float: left;\n  position: relative;\n  padding: 5px;\n  width: 60%; }\n\n.trackingId-border {\n  border-right: 1px solid #ccc; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/routeSheet/print/print.scss
// module id = 1074
// module chunks = 1